var map = {
	"./aquarium.png": 629,
	"./beach.png": 630,
	"./butterflies.png": 631,
	"./fields.png": 632,
	"./garden.png": 633,
	"./island.png": 634,
	"./lake.png": 635,
	"./numbers.png": 636,
	"./relax_on_the_beach.png": 637,
	"./river.png": 638,
	"./sound_of_water.png": 639,
	"./sunset.png": 640,
	"./universe.png": 641,
	"./waves.png": 642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 628;